import React, { useContext, useEffect, useState } from 'react';
import './ProductDisplay.css';
import start_icon from '../Assets/star_icon.png';
import startdull_icon from '../Assets/star_dull_icon.png';
import { ShopContext } from '../../Context/ShopContext';
import { useNavigate } from 'react-router-dom'; // Use useNavigate instead of useHistory

const ProductDisplay = (props) => {
  const { addToCart, updateSizeSelection, saveOrderDetails } = useContext(ShopContext);
  const { product } = props;
  const shippingCharges = 200;
  const [showMessage, setShowMessage] = useState(false);
  const [selectedSize, setSelectedSize] = useState("");
  const [mainImage, setMainImage] = useState(product.image); 
  const [adjustedPrice, setAdjustedPrice] = useState(product.new_price); 
  const [isPopupOpen, setIsPopupOpen] = useState(false); // State for showing popup
  const navigate = useNavigate(); // For navigation

  // Update the main image whenever the product changes
  useEffect(() => {
    setMainImage(product.image);
  }, [product]);

  // Handle adding product to cart
  const handleAddToCart = () => {
    if (selectedSize) {
      updateSizeSelection(product.id, selectedSize); // Update the size in the context
    } else {
      alert("Please select a size!");
      return;
    }

    addToCart(product.id);
    setShowMessage(true);
    setTimeout(() => {
      setShowMessage(false);
    }, 3000);
  };

  // Save the order details and navigate to the Order page
  const handleOrderNow = () => {
    if (!selectedSize) {
      alert("Please select a size!");
      return;
    }

    // Save order details to context
    saveOrderDetails(product, selectedSize, adjustedPrice, 1);

    // Navigate to the Order page with state containing product details and price
    navigate("/order", {
      state: { 
        productsInCart: [{ id: product.id, name: product.name,image:product.image , quantity: 1, size: selectedSize, price: adjustedPrice }], 
        totalAmount: adjustedPrice // You can adjust total amount if needed
      }
    });
  };

  const handleSizeSelect = (size) => {
    setSelectedSize(size); // Update the selected size
    if (size === "Unstitched") {
      setAdjustedPrice(product.new_price - 1000); // Subtract 1000 for Unstitched
    } else {
      setAdjustedPrice(product.new_price); // Reset price if any other size is selected
    }
  };

  const handleImageClick = (image) => {
    setMainImage(image); // Set the clicked image as the main image
  };

  // Open the size chart popup
  const handlePopupOpen = () => {
    setIsPopupOpen(true);
  };

  // Close the size chart popup
  const handlePopupClose = () => {
    setIsPopupOpen(false);
  };

  // Close the popup if clicked outside
  const handleOutsideClick = (e) => {
    if (e.target.classList.contains('popup-overlay')) {
      handlePopupClose();
    }
  };

  return (
    <div className='productdisplay'>
      <div className='productdisplay-left'>
        <div className="productdisplay-img-list">
          {/* Thumbnail images */}
          {product.images && product.images.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Thumbnail ${index + 1}`}
              onClick={() => handleImageClick(image)} 
            />
          ))}
        </div>
        <div className="productdisplay-img">
          {/* Main image */}
          <img className="productdisplay-main-img" src={mainImage} alt="main" />
        </div>
      </div>
      <div className="productdisplay-right">
        <h1>{product.name}</h1>
        <div className="productdisplay-right-star">
          <img src={start_icon} alt="" />
          <img src={start_icon} alt="" />
          <img src={start_icon} alt="" />
          <img src={start_icon} alt="" />
          <img src={startdull_icon} alt="" />
        </div>
        <div className="productdisplay-right-prices">
          <div className="productdisplay-right-price-old">
            <p>PKR {product.old_price}</p>
          </div>
          <div className="productdisplay-right-price-new">
            PKR {adjustedPrice}
          </div>
        </div>
        <div className="productdisplay-right-size">
          <div className="selectsize">
          <h1>Select Size</h1>
          <button onClick={handlePopupOpen} className="size-chart-button">
              View Size Chart
            </button>
          </div>
          <div className="size-container">
            
            <div className="productdisplay-right-sizes">
              {['S', 'M', 'L', 'XL', 'Unstitched'].map((size) => (
                <div
                  key={size}
                  className={`sizeoption ${selectedSize === size ? 'active' : ''}`}
                  onClick={() => handleSizeSelect(size)}
                >
                  {size}
                </div>
              ))}
            </div>
          </div>
        </div>
        {showMessage && (
          <div className="added-message">
            <p>Item added to cart!</p>
          </div>
        )}
        <div className='button-section'>
          <button onClick={handleOrderNow}>Order Now</button> {/* This button now saves the order and navigates */}
          <button onClick={handleAddToCart}>Add To Cart</button>
        </div>
        <p className="productdisplay-right-category">
          <span>Category: </span>Elegant Hand-Embroidered Dresses for Women 
        </p>
        <p className="productdisplay-right-category">
          <span>Tags: </span>Modern, Latest
        </p>
      </div>

      {/* Popup for Size Chart */}
      {isPopupOpen && (
        <div className="popup-overlay" onClick={handleOutsideClick}>
          <div className="popup-content">
            <div className="popup-header">
              <h2>Size Chart</h2>
              <button className="close-popup" onClick={handlePopupClose}>X</button>
            </div>
            <table className="size-chart-table">
              <thead>
                <tr>
                  <th>Measurement</th>
                  <th>Small</th>
                  <th>Medium</th>
                  <th>Large</th>
                  {/* <th>XL</th> */}
                </tr>
              </thead>
              <tbody>
              <tr>
                  <td>Size</td>
                  <td>10 </td>
                  <td>12</td>
                  <td>14</td>
                  {/* <td>17"</td> */}
                </tr>
                <tr>
                  <td>Shoulder</td>
                  <td>14" </td>
                  <td>15"</td>
                  <td>15.5"</td>
                  {/* <td>17"</td> */}
                </tr>
                <tr>
                  <td>Chest</td>
                  <td>19"</td>
                  <td>20"</td>
                  <td>20.5"</td>
                  {/* <td>40"</td> */}
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>18"</td>
                  <td>19.5"</td>
                  <td>20.5""</td>
                  {/* <td>34"</td> */}
                </tr>
                <tr>
                  <td>Bottom(Daman)</td>
                  <td>21"</td>
                  <td>22"</td>
                  <td>23"</td>
                  {/* <td>42"</td> */}
                </tr>
                <tr>
                  <td>Sleeve Length</td>
                  <td>21"</td>
                  <td>22"</td>
                  <td>23"</td>
                  {/* <td>42"</td> */}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductDisplay;
